import { render, staticRenderFns } from "./SubApprovalView.vue?vue&type=template&id=74205368"
import script from "./SubApprovalView.vue?vue&type=script&lang=js"
export * from "./SubApprovalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports